import { BehaviorSubject } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SessionService } from '../../session/session.service';

@Injectable()
export class PageLoaderService implements OnDestroy {
  public pageLoading$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  private lastRouteRendered: string = null;
  private settingsLoaded = false;
  private productsLoaded = false;
  private timeOuts: Array<number> = [];
  private urlsToIgnore: Array<RegExp> = [
    /^\/login.*/,
    /^\/switch-account.*/,
    /^\/404.*/
  ];

  constructor(private router: Router, private session: SessionService) {
    this.router.events
      .pipe(
        filter((event: RouterEvent) => {
          if (
            event instanceof NavigationEnd &&
            event.urlAfterRedirects !== this.lastRouteRendered &&
            this.isNotIgnoredUrl(event.urlAfterRedirects)
          ) {
            this.lastRouteRendered = event.urlAfterRedirects;
            this.session.redirectTo = event.urlAfterRedirects;
            if (this.shouldShowLoading(event.urlAfterRedirects)) {
              this.setLoading();
              return true;
            }
          }
          return false;
        })
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this.timeOuts.forEach((timeOut: number) => {
      clearTimeout(timeOut);
    });
  }

  public setLoading(): void {
    this.timeOuts.push(setTimeout(() => this.pageLoading$.next(true)));
  }
  public setLoaded(): void {
    this.timeOuts.push(setTimeout(() => this.pageLoading$.next(false)));
  }

  private shouldShowLoading(url: string): boolean {
    if (url.indexOf('/settings') === 0) {
      return this.shouldShowLoadingForSettings();
    } else {
      this.settingsLoaded = false;
    }
    if (url.indexOf('/products/layout') === 0) {
      return this.shouldShowLoadingForProducts();
    } else {
      this.productsLoaded = false;
    }
    return true;
  }

  private shouldShowLoadingForSettings(): boolean {
    if (!this.settingsLoaded) {
      this.settingsLoaded = true;
      return true;
    }
    return false;
  }

  private shouldShowLoadingForProducts(): boolean {
    if (!this.productsLoaded) {
      this.productsLoaded = true;
      return true;
    }
    return false;
  }

  private isNotIgnoredUrl(url: string): boolean {
    return (
      this.urlsToIgnore.filter(
        (ignoredUrl: RegExp) => url.search(ignoredUrl) > -1
      ).length === 0
    );
  }
}
